import i18n from 'i18next';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { useModal } from 'react-modal-hook';
import PropTypes from 'prop-types';
import { FormModal } from '../../../../../common/components/modals';
import contactsFormSchema from '../../../../schemas/contactsFormSchema';
import ContactsFormFields from './fields/ContactsFormFields';

const ContactsForm = ({ jurisdictionIndex, onSubmit }) => {
  const { values, setFieldValue } = useFormikContext();

  const handleModalSubmit = useCallback(
    (modalValues) => {
      const filteredValues = modalValues;
      filteredValues.contacts.pop();
      setFieldValue(`jurisdictions.${jurisdictionIndex}.contacts`, filteredValues.contacts);
      onSubmit();
    },
    [onSubmit, jurisdictionIndex, setFieldValue]
  );

  const handleCancel = useCallback(() => {
    onSubmit();
  }, [onSubmit]);

  const initialValues = useMemo(() => {
    let contacts = [];

    if (values.jurisdictions[jurisdictionIndex].contacts) {
      contacts = values.jurisdictions[jurisdictionIndex].contacts.map((contact) => ({
        zoneId: values.jurisdictions[jurisdictionIndex].zoneId,
        id: contact.id,
        name: contact.name || '',
        phoneNumber: contact.phoneNumber || '',
        email: contact.email || '',
      }));
    }

    return { contacts };
  }, [values, jurisdictionIndex]);

  const [showModal, hideModal] = useModal(
    () => (
      <FormModal
        title={i18n.t('mission.editContactInformation')}
        closeModal={hideModal}
        onCancelClick={handleCancel}
        formValues={initialValues}
        validationSchema={contactsFormSchema}
        onSubmitClick={handleModalSubmit}>
        {({ values: modalValues, setFieldValue: setModalFieldValue }) => (
          <ContactsFormFields values={modalValues} setFieldValue={setModalFieldValue} zoneId={values.jurisdictions[jurisdictionIndex].zoneId} />
        )}
      </FormModal>
    ),
    [initialValues, handleModalSubmit]
  );

  useEffect(() => {
    showModal();
  }, [showModal]);

  return null;
};

ContactsForm.propTypes = {
  jurisdictionIndex: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ContactsForm;
